import { type Action, createStore, createHook } from 'react-sweet-state';
import {
	setTitleFilter,
	setAuthorsFilter,
	setReviewersFilter,
	setStatusFilter,
	setRepositoryFilter,
	setSortInfo,
	setPullRequestTableOptions,
} from './actions';
import type {
	PullRequestTableOptions,
	PullRequestFiltersApplied,
	PullRequestFilters,
} from './types';

const initialPullRequestTableFilters: PullRequestFilters = {
	titleFilter: '',
	authorsFilter: [],
	reviewersFilter: [],
	statusFilter: [],
	repositoryFilter: [],
};

export const initialPullRequestTableOptions: PullRequestTableOptions = {
	sortKey: '',
	sortOrder: '',
	...initialPullRequestTableFilters,
};

const resetState =
	(): Action<PullRequestTableOptions> =>
	({ setState }) => {
		setState(initialPullRequestTableOptions);
	};

const resetFilters =
	(): Action<PullRequestTableOptions> =>
	({ getState, setState }) => {
		setState({ ...getState(), ...initialPullRequestTableFilters });
	};

export const actions = {
	setTitleFilter,
	setAuthorsFilter,
	setReviewersFilter,
	setStatusFilter,
	setRepositoryFilter,
	setSortInfo,
	resetFilters,
	resetState,
	setPullRequestTableOptions,
} as const;

export type Actions = typeof actions;

// @ExportForTesting
export const Store = createStore<PullRequestTableOptions, Actions>({
	name: 'codePagePullRequestFilters',
	initialState: initialPullRequestTableOptions,
	actions,
});

export const usePullRequestTableOptionsStore = createHook(Store);

const getHasFiltersApplied = (state: PullRequestTableOptions): PullRequestFiltersApplied => ({
	titleFilter: state.titleFilter !== initialPullRequestTableOptions.titleFilter,
	authorsFilter: state.authorsFilter.length > 0,
	reviewersFilter: state.reviewersFilter.length > 0,
	statusFilter: state.statusFilter.length > 0,
	repositoryFilter: state.repositoryFilter.length > 0,
});

export const useAppliedPullRequestFilters = createHook(Store, {
	selector: getHasFiltersApplied,
});
